export const SABRE_SEGMENT_API_PATH = {
  POST_DEFAULT_STATS: "v1/flights/sabre_segment/stats/",
  POST_DEFAULT_LIST: "v1/flights/sabre_segment/list/",
};
